/* Joulux · hex grid SVG art + scroll reveal (ported from gaga static store) */
(function (global) {
  "use strict";

  function hexPoints(cx, cy, r) {
    const pts = [];
    for (let i = 0; i < 6; i++) {
      const a = (Math.PI / 3) * i;
      pts.push([cx + r * Math.cos(a), cy + r * Math.sin(a)]);
    }
    return pts.map(function (p) { return p[0].toFixed(1) + "," + p[1].toFixed(1); }).join(" ");
  }

  /* Ambient background hex field */
  function hexField(cols, rows, seed) {
    var r = 54;
    var dx = r * 1.5;
    var dy = r * Math.sqrt(3);
    var w = cols * dx + r;
    var h = rows * dy + r;
    var cells = "";
    var s = seed || 1;
    var rand = function () { s = (s * 9301 + 49297) % 233280; return s / 233280; };
    for (var row = 0; row < rows; row++) {
      for (var col = 0; col < cols; col++) {
        var cx = col * dx + (row % 2 ? dx / 2 : 0) + r * 0.5;
        var cy = row * dy * 0.75 + r * 0.5;
        var lit = rand();
        var op = (lit * 0.5).toFixed(2);
        var stroke = lit > 0.6 ? "#ffb429" : "#5a4a2a";
        var sw = lit > 0.6 ? "1.5" : "0.8";
        cells += '<polygon points="' + hexPoints(cx, cy, r - 4) + '" fill="none" stroke="' + stroke + '" stroke-width="' + sw + '" opacity="' + op + '"/>';
      }
    }
    return '<svg viewBox="0 0 ' + w + " " + h + '" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" aria-hidden="true">' + cells + "</svg>";
  }

  global.JouluxArt = { hexField: hexField, hexPoints: hexPoints };

  /* Boot: fill [data-jx-hexfield] + reveal-on-scroll */
  function boot() {
    document.querySelectorAll("[data-jx-hexfield]").forEach(function (el) {
      var cols = parseInt(el.getAttribute("data-jx-hexfield"), 10) || 14;
      var seed = parseInt(el.getAttribute("data-jx-seed"), 10) || 42;
      el.innerHTML = hexField(cols, 8, seed);
    });

    var els = document.querySelectorAll(".jx .reveal");
    if (!("IntersectionObserver" in global)) {
      els.forEach(function (el) { el.classList.add("jx-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("jx-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  /* Re-run for theme editor section reloads */
  document.addEventListener("shopify:section:load", boot);
})(window);
